import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyle = makeStyles(theme => ({
  root: {
    background: theme.palette.darkGrey,
    height: props => `${props.height}px`,
  },
}));

export const Divider = ({ height }) => {
  const styles = useStyle({ height });
  return <Box component="div" className={styles.root} />;
};

Divider.propTypes = {
  height: PropTypes.number.isRequired,
};
